var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcPharmacyOn = function SvgIcPharmacyOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8.182,
    height: 18.692,
    x: 15.477,
    y: 2.409,
    stroke: "#1D85FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    rx: 4.091,
    transform: "rotate(43.563 15.477 2.409)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 18,
    height: 18,
    x: 3,
    y: 3,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 7.85,
    height: 18.638,
    x: 15.438,
    y: 2.447,
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    rx: 3.925,
    transform: "rotate(43.563 15.438 2.447)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D85FF",
    d: "m7.672 7.25 9.613 9.14L9.67 24.4.056 15.258z"
  }))));
};
export default SvgIcPharmacyOn;